export const bakeryProducts = [
  {
    product_id: "BD-001",
    name: "Challah Bread",
    description: "Braided, rich, and slightly sweet, ideal for special occasions.",
    category: "Bread",
    price: 10.38,
    availability: "Seasonal",
    ingredients: "whole wheat flour, rye flour, oats, flax seeds, water, salt, yeast",
    rating: 3.7,
    release_date: "2024-02-09",
    tags: ["seasonal"],
    image_url: "https://frankiesbakery.com/images/bd_001.jpg",
    localImage: "/img/products/bd_001.jpg",
  },
  {
    product_id: "BD-002",
    name: "Rustic Ciabatta",
    description: "Light and airy Italian bread with a rustic texture and crisp crust.",
    category: "Bread",
    price: 6.42,
    availability: "In Stock",
    ingredients: "bread flour, water, olive oil, salt, yeast",
    rating: 3.7,
    release_date: "2024-03-01",
    tags: ["artisan", "classic"],
    image_url: "https://frankiesbakery.com/images/bd_002.jpg",
    localImage: "/img/products/bd_002.jpg",
  },
  {
    product_id: "BD-005",
    name: "Cranberry Walnut Loaf",
    description: "Sweet cranberries and crunchy walnuts baked into a hearty rustic loaf.",
    category: "Bread",
    price: 13.3,
    availability: "Out of Stock",
    ingredients: "bread flour, dried cranberries, walnuts, water, salt, sourdough starter",
    rating: 4.6,
    release_date: "2024-02-25",
    tags: ["seasonal", "artisan", "holiday"],
    image_url: "https://frankiesbakery.com/images/bd_005.jpg",
    localImage: "/img/products/bd_005.jpg",
  },
  {
    product_id: "BD-010",
    name: "Baguette",
    description: "Braided, rich, and slightly sweet, ideal for special occasions.",
    category: "Bread",
    price: 14.84,
    availability: "In Stock",
    ingredients: "flour, water, salt, sourdough starter",
    rating: 3.5,
    release_date: "2024-02-12",
    tags: ["holiday", "sweet", "best-seller"],
    image_url: "https://frankiesbakery.com/images/bd_010.jpg",
    localImage: "/img/products/bd_010.jpg",
  },
  {
    product_id: "BD-012",
    name: "Rye Bread",
    description: "Sweet cranberries and crunchy walnuts baked into a rustic loaf.",
    category: "Bread",
    price: 11.85,
    availability: "Seasonal",
    ingredients: "whole wheat flour, rye flour, oats, flax seeds, water, salt, yeast",
    rating: 3.5,
    release_date: "2024-01-19",
    tags: ["best-seller"],
    image_url: "https://frankiesbakery.com/images/bd_012.jpg",
    localImage: "/img/products/bd_012.jpg",
  },
  {
    product_id: "BD-013",
    name: "Rosemary Sea Salt Focaccia",
    description: "Crispy on the outside, soft on the inside, and perfect for dipping in olive oil.",
    category: "Bread",
    price: 8.57,
    availability: "Out of Stock",
    ingredients: "bread flour, olive oil, rosemary, sea salt, water, yeast",
    rating: 4.8,
    release_date: "2024-04-23",
    tags: ["savory", "classic"],
    image_url: "https://frankiesbakery.com/images/bd_013.jpg",
    localImage: "/img/products/bd_013.jpg",
  },
  {
    product_id: "BD-016",
    name: "Sourdough Loaf",
    description: "Artisan sourdough with a crispy crust and chewy interior.",
    category: "Bread",
    price: 12.19,
    availability: "Out of Stock",
    ingredients: "whole wheat flour, rye flour, oats, flax seeds, water, salt, yeast",
    rating: 4,
    release_date: "2024-05-01",
    tags: ["best-seller", "vegan"],
    image_url: "https://frankiesbakery.com/images/bd_016.jpg",
    localImage: "/img/products/bd_016.jpg",
  },
  {
    product_id: "BR-004",
    name: "Salted Caramel Brownie",
    description: "A perfect balance of sweet and salty with a gooey caramel swirl.",
    category: "Brownies",
    price: 6.92,
    availability: "In Stock",
    ingredients: "flour, sugar, cocoa powder, butter, eggs, vanilla extract, salt, walnuts",
    rating: 3.7,
    release_date: "2024-05-22",
    tags: ["holiday", "seasonal", "new-arrival"],
    image_url: "https://frankiesbakery.com/images/br_004.jpg",
    localImage: "/img/products/br_004.jpg",
  },
  {
    product_id: "BR-007",
    name: "Raspberry Fudge Brownie",
    description: "A perfect balance of sweet and salty with a gooey caramel swirl.",
    category: "Brownies",
    price: 12.98,
    availability: "Out of Stock",
    ingredients: "flour, sugar, cocoa powder, butter, eggs, vanilla extract, salt",
    rating: 3.5,
    release_date: "2024-05-16",
    tags: ["best-seller", "new-arrival"],
    image_url: "https://frankiesbakery.com/images/br_007.jpg",
    localImage: "/img/products/br_007.jpg",
  },
  {
    product_id: "BR-008",
    name: "Espresso Swirl Brownie",
    description: "Sweet raspberries swirled into a dark chocolate brownie.",
    category: "Brownies",
    price: 3.16,
    availability: "Out of Stock",
    ingredients: "flour, sugar, cocoa powder, butter, eggs, vanilla extract, salt, walnuts",
    rating: 4.3,
    release_date: "2024-03-22",
    tags: ["vegan", "best-seller"],
    image_url: "https://frankiesbakery.com/images/br_008.jpg",
    localImage: "/img/products/br_008.jpg",
  },
  {
    product_id: "BR-009",
    name: "Walnut Brownie",
    description: "A buttery, vanilla-rich blondie with white chocolate chips.",
    category: "Brownies",
    price: 11.72,
    availability: "In Stock",
    ingredients: "flour, sugar, cocoa powder, butter, eggs, vanilla extract, salt, walnuts",
    rating: 4.6,
    release_date: "2024-04-15",
    tags: ["holiday", "seasonal"],
    image_url: "https://frankiesbakery.com/images/br_009.jpg",
    localImage: "/img/products/br_009.jpg",
  },
  {
    product_id: "BR-015",
    name: "Fudgy Chocolate Brownie",
    description: "Rich and decadent, our fudgy brownie is a chocolate lover's dream.",
    category: "Brownies",
    price: 9.16,
    availability: "Out of Stock",
    ingredients: "flour, sugar, cocoa powder, butter, eggs, vanilla extract, salt, walnuts",
    rating: 3.3,
    release_date: "2024-03-01",
    tags: ["classic", "seasonal"],
    image_url: "https://frankiesbakery.com/images/br_015.jpg",
    localImage: "/img/products/br_015.jpg",
  },
  {
    product_id: "BR-018",
    name: "Blondie Brownie",
    description: "Classic brownie with crunchy walnuts for added texture.",
    category: "Brownies",
    price: 2.27,
    availability: "In Stock",
    ingredients: "flour, sugar, cocoa powder, butter, eggs, vanilla extract, salt, walnuts",
    rating: 4,
    release_date: "2024-05-08",
    tags: ["holiday"],
    image_url: "https://frankiesbakery.com/images/br_018.jpg",
    localImage: "/img/products/br_018.jpg",
  },
  {
    product_id: "CK-003",
    name: "Macadamia Nut Cookie",
    description: "Spiced and sweet, a holiday classic perfect for any time of year.",
    category: "Cookies",
    price: 6.21,
    availability: "Out of Stock",
    ingredients: "flour, butter, sugar, brown sugar, eggs, vanilla extract, baking soda, chocolate chips",
    rating: 3.1,
    release_date: "2024-01-23",
    tags: ["gluten-free", "dairy-free"],
    image_url: "https://frankiesbakery.com/images/ck_003.jpg",
    localImage: "/img/products/ck_003.jpg",
  },
  {
    product_id: "CK-006",
    name: "Oatmeal Raisin Cookie",
    description: "Soft-baked oatmeal cookie loaded with raisins and warm cinnamon spice.",
    category: "Cookies",
    price: 6.73,
    availability: "In Stock",
    ingredients: "flour, butter, sugar, brown sugar, eggs, vanilla extract, baking soda, oats, raisins, cinnamon",
    rating: 4.4,
    release_date: "2024-03-05",
    tags: ["classic", "spiced", "new-arrival"],
    image_url: "https://frankiesbakery.com/images/ck_006.jpg",
    localImage: "/img/products/ck_006.jpg",
  },
  {
    product_id: "CK-011",
    name: "Peanut Butter Cookie",
    description: "Rich and nutty, a timeless favorite for peanut butter lovers.",
    category: "Cookies",
    price: 3.57,
    availability: "Seasonal",
    ingredients: "flour, butter, peanut butter, sugar, brown sugar, eggs, vanilla extract, baking soda",
    rating: 3.6,
    release_date: "2024-03-04",
    tags: ["nutty", "classic"],
    image_url: "https://frankiesbakery.com/images/ck_011.jpg",
    localImage: "/img/products/ck_011.jpg",
  },
  {
    product_id: "CK-014",
    name: "Snickerdoodle",
    description: "Buttery cookies packed with crunchy macadamia nuts.",
    category: "Cookies",
    price: 3.3,
    availability: "Seasonal",
    ingredients: "flour, butter, sugar, brown sugar, eggs, vanilla extract, baking soda, chocolate chips",
    rating: 3.7,
    release_date: "2024-04-07",
    tags: ["seasonal"],
    image_url: "https://frankiesbakery.com/images/ck_014.jpg",
    localImage: "/img/products/ck_014.jpg",
  },
  {
    product_id: "CK-017",
    name: "White Chocolate Macadamia Cookie",
    description: "Buttery cookies packed with crunchy macadamia nuts and creamy white chocolate.",
    category: "Cookies",
    price: 2.11,
    availability: "Out of Stock",
    ingredients: "flour, butter, sugar, brown sugar, eggs, vanilla extract, baking soda, white chocolate chips, macadamia nuts",
    rating: 3.7,
    release_date: "2024-01-09",
    tags: ["new-arrival", "nutty"],
    image_url: "https://frankiesbakery.com/images/ck_017.jpg",
    localImage: "/img/products/ck_017.jpg",
  },
  {
    product_id: "CK-019",
    name: "Cinnamon Sugar Cookie",
    description: "Cinnamon-sugar coated delight, soft and full of flavor.",
    category: "Cookies",
    price: 11.85,
    availability: "Seasonal",
    ingredients: "flour, butter, sugar, brown sugar, eggs, vanilla extract, cinnamon, baking soda",
    rating: 4,
    release_date: "2024-04-02",
    tags: ["best-seller", "classic", "seasonal"],
    image_url: "https://frankiesbakery.com/images/ck_019.jpg",
    localImage: "/img/products/ck_019.jpg",
  },
  {
    product_id: "CK-020",
    name: "Chocolate Chip Cookie",
    description: "Our classic chocolate chip cookie, soft and chewy with melty chocolate.",
    category: "Cookies",
    price: 3.05,
    availability: "Seasonal",
    ingredients: "flour, butter, sugar, brown sugar, eggs, vanilla extract, baking soda, oats, raisins, cinnamon",
    rating: 3.9,
    release_date: "2024-01-30",
    tags: ["nut-free", "vegan"],
    image_url: "https://frankiesbakery.com/images/ck_020.jpg",
    localImage: "/img/products/ck_020.jpg",
  },
];
